import {SelectionOrNull, Selection} from "../models";


export class FetchSelections {
  static readonly type = '[Selections] Fetch';

  constructor() {
  }
}

export class FetchFiltered {
  static readonly type = '[Selections] FetchFiltered';

  constructor(public payload: any) {
  }
}

export class AddSelection {

  static readonly type = '[Selections] Add';

  constructor(public payload: any) {
  }
}

export class EditSelection {

  static readonly type = '[Selections] Edit';

  constructor(public payload: SelectionOrNull) {
  }
}

export class CancelEditSelection {

  static readonly type = '[Selections] Cancel';

  constructor() {
  }
}

export class UpdateSelection {

  static readonly type = '[Selections] Update';

  constructor(public payload: any) {
  }
}

export class DeleteSelection {

  static readonly type = '[Selections] Delete';

  constructor(public selection: Selection) {
  }
}

